import React, { Component } from 'react'
import history from '../../routes/history';
import { DemoContainer } from './common/controls';
import { Box } from '../../third-party-components/material-ui';

class DemographicOverQuota extends Component {
    componentDidMount() {
        window.history.pushState(null, null, history.location.href);
        window.onpopstate = function(event) {
            history.go(1);
        };
    }

    render() {
        return (
            <DemoContainer>
                <Box display="flex" justifyContent="center" alignContent="center" textAlign="center">
                  Thank you for your willingness to participate. Unfortunately, we have all our target numbers for this assessment.<br/><br/>
                  Please close the browser to exit.
                </Box>
            </DemoContainer>
        )
    }
}

export default DemographicOverQuota;